import { SearchTarget } from "../enums/SearchTarget";
import { DispatchSearchType } from "../enums/dispatchSearchType";
import { SearchBy } from "../enums/SearchBy";

export class DQOISearchParam
{
    userId: any;
    search: string;
    isDeep: boolean;
    minStringSize: number;
    startDate: Date;
    endDate: Date;
    isOpen: boolean;
    customerId: any;
    locationId: any;
    quoteNumber: string;
    invoiceNumber: string;
    orderNumber: string;
    inventoryNumber: string;
    searchBy: SearchBy = SearchBy.any;
    searchType: DispatchSearchType = DispatchSearchType.all;
    searchTarget: SearchTarget;
    categoryId: any;
    subCategoryId: any;
    typeId: any;
    manufacturerId: any;
    companyId: any;
    skip: number = 0;
    take: number = 0;
}
